import {HttpRequest} from "../utils/httpRequest";

let Upload = {
    /**
     * 获取文档预览url地址
     * @param params
     * @returns {*}
     */
    getPreviewUrl(params) {
        return HttpRequest.getRequest({
            url: '/edu/upload/preview',
            method: 'get',
            data: params
        });
    }
};
export {Upload}
